import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TaskListComponent } from '@features/tasks/views/list/task-list.component';

import { CompanyLayoutComponent } from './views/company/layout/company-layout.component';
import { CompanySummaryComponent } from './views/company/summary/company-summary.component';
import { ContactListComponent } from './views/contact/list/contact-list.component';
import { IndividualLayoutComponent } from './views/individual/layout/individual-layout.component';
import { IndividualSummaryComponent } from './views/individual/summary/individual-summary.component';
import { TrustLayoutComponent } from './views/trust/layout/trust-layout.component';
import { TrustSummaryComponent } from './views/trust/summary/trust-summary.component';
import { DiaryNoteListComponent } from '@features/diary-notes/views/list/diary-note-list.component';
import { ClientProductListComponent } from './views/contact/product-list/product-list.component';
import { ClientOpportunityListComponent } from './views/contact/opportunity-list/contact-opportunity-list.component';
import { RoleGuard } from '@core/guards/role/role.guard';
import { Claims } from '@core/authentication/claims';
import { IndividualAuditListComponent } from './views/audit/individual-audit-list.component';
import { CompanyAuditListComponent } from './views/audit/company-audit-list.component';
import { TrustAuditListComponent } from './views/audit/trust-audit-list.component';
import { companyResolver } from './resolvers/company.resolver';
import { individualResolver } from './resolvers/individual.resolver';
import { trustResolver } from './resolvers/trust.resolver';

const routes: Routes = [
  {
    path: '',
    component: ContactListComponent,
    pathMatch: 'full',
    title: 'Contacts List'
  },
  {
    path: 'Individual/:individualId',
    component: IndividualLayoutComponent,
    resolve: { individual: individualResolver },
    children: [
      {
        path: '',
        component: IndividualSummaryComponent,
        pathMatch: 'full',
        title: 'Contact - Individual'
      },
      {
        path: 'Notes',
        component: DiaryNoteListComponent,
        title: 'Contact - Individual Notes'
      },
      {
        path: 'Opportunities',
        component: ClientOpportunityListComponent,
        title: 'Contact - Individual Opportunities'
      },
      {
        path: 'Products',
        component: ClientProductListComponent,
        title: 'Contact - Individual Products'
      },
      {
        path: 'Tasks',
        component: TaskListComponent,
        title: 'Contact - Individual Tasks'
      },
      {
        path: 'Audit',
        component: IndividualAuditListComponent,
        canActivate: [RoleGuard],
        title: 'Contact - Individual Audit',
        data: {
          requiredRole: Claims.UserRoles.NetworkAdministrator
        }
      }
    ]
  },
  {
    path: 'Company/:companyId',
    component: CompanyLayoutComponent,
    resolve: { company: companyResolver },
    children: [
      {
        path: '',
        component: CompanySummaryComponent,
        pathMatch: 'full',
        title: 'Contact - Company'
      },
      {
        path: 'Notes',
        component: DiaryNoteListComponent,
        title: 'Contact - Company Notes'
      },
      {
        path: 'Opportunities',
        component: ClientOpportunityListComponent,
        title: 'Contact - Company Opportunities'
      },
      {
        path: 'Products',
        component: ClientProductListComponent,
        title: 'Contact - Company Products'
      },
      {
        path: 'Tasks',
        component: TaskListComponent,
        title: 'Contact - Company Tasks'
      },
      {
        path: 'Audit',
        component: CompanyAuditListComponent,
        canActivate: [RoleGuard],
        title: 'Contact - Company Audit',
        data: {
          requiredRole: Claims.UserRoles.NetworkAdministrator
        }
      }
    ]
  },
  {
    path: 'Trust/:trustId',
    component: TrustLayoutComponent,
    resolve: { trust: trustResolver },
    children: [
      {
        path: '',
        component: TrustSummaryComponent,
        pathMatch: 'full',
        title: 'Contact - Trust'
      },
      {
        path: 'Notes',
        component: DiaryNoteListComponent,
        title: 'Contact - Trust Notes'
      },
      {
        path: 'Opportunities',
        component: ClientOpportunityListComponent,
        title: 'Contact - Trust Opportunities'
      },
      {
        path: 'Products',
        component: ClientProductListComponent,
        title: 'Contact - Trust Products'
      },
      {
        path: 'Tasks',
        component: TaskListComponent,
        title: 'Contact - Trust Tasks'
      },
      {
        path: 'Audit',
        component: TrustAuditListComponent,
        canActivate: [RoleGuard],
        title: 'Contact - Trust Audit',
        data: {
          requiredRole: Claims.UserRoles.NetworkAdministrator
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactsRoutingModule {}
